import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import {
	Button,
	Collapse,
	List,
	ListItemButton,
	ListItemText,
	IconButton
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MetaDataValidation } from "./ValidateAPITypes";
import Validation from "./Validation";
import { setAPIResponse, setAPIState } from "../../stateManagement/actions/validateAPIActions";
import { useSelector } from "react-redux";
import { fetchApiData } from "../../services/validateAPIService";
import store from "../../stateManagement/store";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const ValidateCollapse = (
	props: {
		name: string;
		id: string;
		validations: MetaDataValidation[];
		apiId: string;
		setCurrentSelectedResponse: React.Dispatch<React.SetStateAction<string | null>>;
	}): JSX.Element => {
	const { translate } = usePortalTranslation();
	const CUR_COMPONENT = "Validate API";
	const {
		name,
		validations,
		id,
		setCurrentSelectedResponse,
		apiId,
	} = props;
	const [open, setOpen] = useState<boolean>(true);
	const { token } = useSelector(() => store.getState()?.validateAPIState ?? "")
	const responseData = useSelector(() => id ? store.getState()?.validateAPIState?.apiResponses[id] : null);
	const [apiLoading, setApiLoading] = useState<boolean>(false);

	async function callAPI() {
		try {
			setApiLoading(true)
			const data = await fetchApiData(apiId, token);
			setAPIResponse({ data, type: "success" }, apiId);
		} catch (err: any) {
			console.error(err)
			setAPIResponse({ error: err?.data?.message != "" ? err?.data?.message : "Some Error Occured", type: "error" }, apiId);
		} finally {
			setApiLoading(false);
			setAPIState("cache", apiId);
		}
	}

	useEffect(() => {
		if (token)
			callAPI();
	}, [token])

	return (
		<>
			<ListItemButton disableRipple onClick={() => setOpen(!open)}>
				<ListItemText
					primary={translate(TranslationEnum.validate_api,name)}
					primaryTypographyProps={{
						fontWeight: "800",
						variant: "subtitle1",
					}}
				/>
				{responseData && !apiLoading && (
					<Button
						variant="outlined"
						className="viewResponseBtn"
						size="small"
						onClick={(e) => {
							setCurrentSelectedResponse(id);
							e.stopPropagation();
						}}
					>
						{translate(TranslationEnum.validate_api,"View Response")}
					</Button>
				)}
				<IconButton size="small" className="validateCollapseToggleBtn">
					{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
				</IconButton>
			</ListItemButton>

			<Collapse timeout="auto" in={open} className="collapse" unmountOnExit>
				<List className="validation-list" disablePadding component={"div"}>
					{validations.map(
						({
							id,
							name,
							params,
							status,
							validateId,
						}: MetaDataValidation) => {
							status = status.toLowerCase().trim();
							return (
								<Validation
									key={id}
									id={id}
									validateId={validateId}
									name={translate(TranslationEnum.validate_api,name)}
									status={status}
									params={params}
									responseData={responseData || null}
									loading={apiLoading}
								/>
							);
						}
					)}
				</List>
			</Collapse>
		</>
	);
};

export default ValidateCollapse;
